// extracted by mini-css-extract-plugin
module.exports = {"loading-text-placeholder":"loading-text__loading-text-placeholder___1Ehjg"};